import { gql } from "@apollo/client";
import { useEffect, useState } from "react";
import { gq } from "../helper";
import MetricTable from "./MetricTable";

export default function HorseMetrics({ hId }) {
  const [races, setRaces] = useState({});
  const [total, setTotal] = useState(0);

  useEffect(() => {
    gq.query({
      variables: {
        first: 100,
        input: {
          onlyMyRacehorses: true,
          isTournament: false,
          distance: {
            from: 1000,
            to: 2600,
          },
          horses: [hId],
        },
      },
      query: gql`
        query GetRaceResults(
          $input: GetRaceResultsInput
          $before: String
          $after: String
          $first: Int
          $last: Int
        ) {
          raceResults: get_race_results(
            input: $input
            before: $before
            after: $after
            first: $first
            last: $last
          ) {
            edges {
              node {
                name
                length
                startTime: start_time
                fee
                weather
                class
                raceId
                horses {
                  horseId: horse_id
                  position: final_position
                  gate
                  races
                  coat
                  winRate: win_rate
                  career
                }
              }
            }
          }
        }
      `,
    }).then((res) => {
      const data = res.data.raceResults.edges;

      let result = {};

      setTotal(data.length);

      data.forEach((r) => {
        const node = r.node;

        const h = node.horses.find((horse) => horse.horseId === hId);
        const final = {
          weather: node.weather,
          length: node.length,
          raceId: node.raceId,
          class: node.class,
          ...h,
        };

        if (!result[final.length]) {
          result[final.length] = [];
        }
        result[final.length].push(final);
      });
      setRaces(result);
    });
  }, [hId]);

  return (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      {Object.entries(races).map(([key, value]) => (
        <MetricTable key={key} total={total} distance={key} races={value} />
      ))}
    </div>
  );
}
